<style>
  .button-like-link {
    background: none !important;
    border: none;
    padding: 0 !important;
    /*optional*/
    font-family: Roboto;
    /*input has OS specific font-family*/
    color: #069;
    text-decoration: underline;
    cursor: pointer;
  }

  @media screen and (max-width: 767px) {
    .dropdown-list.dropdown-menu.dropdown-menu-right.shadow.animated--grow-in {
      position: fixed;
      top: 83px;
      left: 1rem;
      width: calc(100vw - 2rem);
      max-height: calc(100vh - 83px);
      overflow-y: auto;
    }
  }
  
  .wrapper__notify {
    max-height: calc(100vh - 83px) !important;
    overflow-y: auto !important;
  }
</style>

<a class="nav-link dropdown-toggle nav-icon" id="alertsDropdown" role="button" data-toggle="dropdown"
  aria-haspopup="true" aria-expanded="false" [matTooltip]="'notify.noti_tooltip'| translate" (click)="clearSelection()">
  <i class="fa fa-bell-o fa-fw vt-cursor-pointer" style="margin-left: -3px;"></i>
  <!-- Counter - Alerts -->
  <span class="badge badge-danger badge-counter">{{ totalUnread == 0 ? '': totalUnread}}</span>
</a>
<!-- Dropdown - Alerts -->
<div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in wrapper__notify" aria-labelledby="alertsDropdown">
  <h6 class="dropdown-header">
    {{'header.notify' | translate}}
  </h6>
  <a class="dropdown-item d-flex align-items-center" style="cursor: pointer;" *ngFor="let notify of notifies"
    (click)="viewDetail(notify)">
    <!-- Icon -->
    <div class="mr-3">
      <div class="icon-circle {{notify.status ? 'bg-secondary' : 'bg-primary'}}">
        <em class="fa {{notify.status ? 'fa-check-square-o' : 'fa-flag-checkered'}} text-white"></em>
      </div>
    </div>
    <!-- Text -->
    <div [title]="parsedText(getContent(notify))">
      <p class="mt-2 text-dark" *ngIf="notify.status == false" style="white-space: pre-line;">
        <strong  [innerHTML]="getContent(notify)"></strong>
      </p>
      <p class="mt-2 text-dark"  [innerHTML]="getContent(notify)" *ngIf="notify.status == true" style="white-space: pre-line;">
        
      </p>
      <div class="small text-gray-700" style="margin-top: -15px;">{{notify.createdTime | dateformat}}</div>
    </div>
  </a>
  <a *ngIf="notifies?.length > 0" class="dropdown-item text-center small text-gray-700"
    routerLink="/home-enterprise/notify">{{'notify.view_all' | translate}}</a>
  <span *ngIf="notifies?.length === 0" class="dropdown-item text-center small text-gray-700">{{'notify.no_notify' |
    translate}}</span>
</div>